import { render, staticRenderFns } from "./ProjectSettingsAdvanced.vue?vue&type=template&id=42bd90d0&scoped=true&"
import script from "./ProjectSettingsAdvanced.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSettingsAdvanced.vue?vue&type=style&index=0&id=42bd90d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd90d0",
  null
  
)

export default component.exports